import { useEffect, useState } from "react";
import { NAV_LINKS, SITE, DEFAULT_WA_MESSAGE, whatsappLink } from "@/constants/site";

export default function Header() {
  const [scrolled, setScrolled] = useState(false);
  const [menuOpen, setMenuOpen] = useState(false);

  useEffect(() => {
    const onScroll = () => setScrolled(window.scrollY > 40);
    onScroll();
    window.addEventListener("scroll", onScroll, { passive: true });
    return () => window.removeEventListener("scroll", onScroll);
  }, []);

  useEffect(() => {
    document.body.style.overflow = menuOpen ? "hidden" : "";
    return () => {
      document.body.style.overflow = "";
    };
  }, [menuOpen]);

  const waLink = whatsappLink(DEFAULT_WA_MESSAGE);

  return (
    <header
      className={`fixed top-0 left-0 right-0 z-50 transition-all duration-500 ${
        scrolled
          ? "bg-background-50/95 backdrop-blur-md border-b border-background-200"
          : "bg-transparent"
      }`}
    >
      <div className="w-full px-4 md:px-8 lg:px-12">
        <div className="flex items-center justify-between h-16 md:h-20">
          {/* Logo */}
          <a href="#top" className="flex flex-col leading-none cursor-pointer">
            <span
              className={`font-heading text-xl md:text-2xl tracking-[0.18em] font-medium transition-colors ${
                scrolled ? "text-foreground-950" : "text-background-50"
              }`}
            >
              DÜZBAĞ LIFE
            </span>
            <span
              className={`text-[10px] md:text-[11px] tracking-[0.28em] uppercase mt-0.5 transition-colors ${
                scrolled ? "text-secondary-600" : "text-accent-300"
              }`}
            >
              {SITE.subtitle}
            </span>
          </a>

          {/* Desktop nav */}
          <nav className="hidden lg:flex items-center gap-7">
            {NAV_LINKS.map((link) => (
              <a
                key={link.href}
                href={link.href}
                className={`text-sm font-medium whitespace-nowrap transition-colors cursor-pointer hover:text-accent-500 ${
                  scrolled ? "text-foreground-700" : "text-background-100"
                }`}
              >
                {link.label}
              </a>
            ))}
          </nav>

          {/* Actions */}
          <div className="flex items-center gap-3">
            <a
              href={waLink}
              target="_blank"
              rel="noopener noreferrer"
              className="hidden sm:inline-flex items-center gap-2 bg-accent-500 hover:bg-accent-600 text-background-50 text-sm font-semibold px-4 md:px-5 py-2.5 rounded-md whitespace-nowrap transition-colors cursor-pointer"
            >
              <i className="ri-calendar-check-line text-base" />
              Rezervasyon Yap
            </a>

            {/* Mobile hamburger */}
            <button
              type="button"
              aria-label="Menüyü aç"
              onClick={() => setMenuOpen((v) => !v)}
              className={`lg:hidden w-10 h-10 flex items-center justify-center rounded-md transition-colors cursor-pointer ${
                scrolled ? "text-foreground-950" : "text-background-50"
              }`}
            >
              <i className={`text-2xl ${menuOpen ? "ri-close-line" : "ri-menu-line"}`} />
            </button>
          </div>
        </div>
      </div>

      {/* Mobile menu */}
      <div
        className={`lg:hidden fixed inset-0 top-16 bg-background-950/98 transition-opacity duration-300 ${
          menuOpen ? "opacity-100 pointer-events-auto" : "opacity-0 pointer-events-none"
        }`}
      >
        <nav className="flex flex-col px-8 pt-8 pb-24 gap-1">
          {NAV_LINKS.map((link) => (
            <a
              key={link.href}
              href={link.href}
              onClick={() => setMenuOpen(false)}
              className="py-4 border-b border-background-800 text-background-100 font-heading text-2xl tracking-wide cursor-pointer hover:text-accent-400 transition-colors"
            >
              {link.label}
            </a>
          ))}
          <a
            href={waLink}
            target="_blank"
            rel="noopener noreferrer"
            className="mt-8 inline-flex items-center justify-center gap-2 bg-accent-500 text-background-50 font-semibold py-4 rounded-md whitespace-nowrap cursor-pointer"
          >
            <i className="ri-whatsapp-line text-xl" />
            WhatsApp Rezervasyon
          </a>
        </nav>
      </div>
    </header>
  );
}